// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"58907da8","349":"a462c6cb","619":"7a5a4dec"}[chunkId] + ".chunk.css";
};